import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Flex,
  Text,
  HStack,
  Box,
} from "@chakra-ui/react";

// Types
import { Props } from "./Props.types";

// Constants
import { TXN_ICONS } from "constants/transactions";
import { getDuration } from "utils/common";

const AllTransaction = ({ txnBatchData, handleTxView, onClear }: Props) => {
  return (
    <>
      <Box
        alignItems="center"
        mt="1rem"
        p="1rem"
        bg="brand.background"
        cursor="pointer"
        borderRadius=" 8px 8px 0 0"
      >
        <HStack justifyContent="space-between">
          <Text fontFamily="medium">Transactions</Text>
          <Text
            size="md"
            fontSize="14px"
            fontFamily="semi-bold"
            color="brand.primary"
            onClick={onClear}
          >
            CLEAR ALL
          </Text>
        </HStack>
      </Box>

      {txnBatchData.length > 0 ? (
        <TableContainer
          maxH="260px"
          overflowY="auto"
          fontSize="14px"
          mb="0.5rem"
          p=" 0 1rem 1rem"
          bg="brand.background"
          borderRadius="0 0 8px 8px"
        >
          <Table variant="simple">
            <Thead>
              <Tr fontSize="12px">
                <Th ml="1rem">TIME</Th>
                <Th>TYPE</Th>
                <Th>AMOUNT</Th>
                <Th pr="0" textAlign="right">
                  STATUS
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {txnBatchData.map((txn) => {
                const { hash, amount, token, status, time, type } = txn;

                return (
                  <Tr key={hash}>
                    <Td px="1rem">{getDuration(time, new Date())} ago</Td>
                    <Td>
                      <Text
                        color="brand.primary"
                        cursor="pointer"
                        onClick={() => handleTxView(hash)}
                      >
                        {type}
                      </Text>
                    </Td>
                    <Td>{amount ? `${amount} ${token}` : "-"}</Td>
                    <Td pr="0" textAlign="center">
                      {TXN_ICONS[status]}
                    </Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
          {txnBatchData.length === 0 && (
            <Flex
              width="100%"
              h="200px"
              justifyContent="center"
              alignItems="center"
            >
              You do not have any transactions
            </Flex>
          )}
        </TableContainer>
      ) : (
        <Box
          mb="0.5rem"
          p=" 0 1rem 1rem"
          bg="brand.background"
          borderRadius="0 0 8px 8px"
        >
          <Text fontSize="12px">Your Transactions will come here</Text>
        </Box>
      )}
      {/* <Alert type="warning" withIcon={true}>
        <Text fontSize="14px" color="#000000" _dark={{ color: "#ffffff" }}>
          Your transactions history resets when you disconnect/switch your
          wallet.
        </Text>
      </Alert> */}
    </>
  );
};

export default AllTransaction;
